import { Box, Grid, Skeleton } from '@mui/material'
import { Archive } from 'react-feather'
import { StatusChip } from '../../../pages/Home/components/StatusChip/StatusChip'

export default function LoadingPreviewCard() {
	return (
		<Box sx={{ width: '100%' }}>
			<Grid container sx={{ py: '16px' }}>
				<Grid
					item
					xs={1}
					sx={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'flex-start',
					}}
				>
					<Archive />
				</Grid>
				<Grid item xs={6}>
					<Box>
						<Skeleton />
						<Box display="flex" flexDirection="row" justifyContent="space-between">
							<Skeleton sx={{ flexGrow: 1, m: '0 2px' }} />
							<span style={{ lineHeight: '30px', marginRight: '2px' }}>▪</span>
							<StatusChip status="LOADING" />
						</Box>
					</Box>
				</Grid>
			</Grid>
		</Box>
	)
}
